import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import { registerQuery, useQuery } from 'data-fetching-client';
import { transformBackendViewToInternalFormat } from '../../viewsSearch/dataOperators/backendViews';
export const SINGLE_VIEW_WITH_SETTINGS_BY_ID_QUERY_NAME = 'singleViewWithSettingsById';
const viewsWithSettingsQueryArgsArgument = ['id', 'objectTypeId', 'namespaceName'];

/**
 * Constructs the appropriate endpoint URL for fetching a view with visualization settings.
 * Handles both default views and custom views with different endpoint patterns.
 */
const buildViewWithSettingsEndpoint = (objectTypeId, viewId, namespaceName, viewType) => {
  const portalId = PortalIdParser.get();
  const isDefaultView = viewType === 'DEFAULT';
  if (isDefaultView) {
    return `/sales/v4/views/default-view/${objectTypeId}/with-visualization-settings?portalId=${portalId}&namespace=${namespaceName}&viewId=${viewId}`;
  }
  return `/sales/v4/views/${objectTypeId}/${viewId}/with-visualization-settings?portalId=${portalId}&namespace=${namespaceName}`;
};
export const SingleViewWithSettingsByIdQuery = registerQuery({
  fieldName: SINGLE_VIEW_WITH_SETTINGS_BY_ID_QUERY_NAME,
  args: viewsWithSettingsQueryArgsArgument,
  fetcher: async args => {
    if (!args.id) {
      throw new Error('SingleViewWithSettingsByIdQuery: missing id in query args');
    }
    const basicView = await http.get(`/sales/v4/views/${args.objectTypeId}/${args.id}?namespace=${args.namespaceName}`, {
      data: args
    });
    const endpoint = buildViewWithSettingsEndpoint(args.objectTypeId, args.id, args.namespaceName, basicView.type);
    const response = await http.get(endpoint);
    const view = transformBackendViewToInternalFormat(response.view || basicView);
    const visualizationSettingsMap = response.visualizationSettingsMap || {};

    // Ensure each visualization setting has the objectTypeId
    const settingsWithObjectTypeId = Object.fromEntries(Object.entries(visualizationSettingsMap).map(([vizType, setting]) => [vizType, setting ? Object.assign({}, setting, {
      objectTypeId: args.objectTypeId
    }) : setting]));
    return {
      view,
      visualizationSettingsMap: settingsWithObjectTypeId
    };
  }
});
export const useFetchSingleViewWithSettings = query => {
  return useQuery(SingleViewWithSettingsByIdQuery, {
    variables: query,
    skip: !query.id
  });
};